import React from 'react';
import { motion } from 'framer-motion'; // Importa motion da framer-motion
import { useInView } from 'react-intersection-observer'; // Importa useInView per rilevare l'entrata nella vista
import { useLanguage } from '../context/LanguageContext'; // Importa useLanguage dal contesto della lingua

function Position() {
    const { isEnLang } = useLanguage(); // Usa il contesto della lingua per determinare la lingua corrente

    const styles = {
        title: {
            fontSize: '35px',
        }
    }

    const { ref, inView } = useInView(); // Hook per rilevare se il componente è nella vista

    const variants = {
        hidden: { opacity: 0, x: -100 }, // Animazione di partenza (nascosto fuori dallo schermo a sinistra)
        visible: { opacity: 1, x: 0 }, // Animazione di entrata (visibile con slide-in)
    };

    // Testi in entrambe le lingue
    const text = {
        en: {
            title: "Strategic Location and Peaceful Atmosphere",
            description: "B&B Alma Suite, although located in Nettuno, is geographically in Anzio. Thanks to this location, the sea is a few kilometers away, and you can enjoy the tourist and cultural attractions of both Anzio and Nettuno."
        },
        it: {
            title: "Posizione Strategica e Atmosfera Tranquilla",
            description: "Il B&B Alma Suite, pur essendo ubicato a Nettuno, si trova geograficamente ad Anzio. Grazie a questa posizione, il mare dista pochi chilometri, e si può godere delle attrazioni turistiche e culturali sia di Anzio che di Nettuno."
        }
    };

    // Scegli i testi in base alla lingua corrente
    const { title, description } = isEnLang ? text.en : text.it;

    return (
        <motion.div
            ref={ref}
            initial="hidden" // Stato iniziale (nascosto)
            animate={inView ? "visible" : "hidden"} // Animazione attivata quando il componente è nella vista
            variants={variants} // Variante per l'animazione
            transition={{ duration: 0.5 }} // Durata dell'animazione
            className="position l-960"
        >
            <h2>{title}</h2>
            <p>{description}</p>
        </motion.div>
    )
}

export default Position;
